import { useEffect, useState, useMemo, useCallback } from "react";
import WebSocketManager from "../../../../ws/client";

export function useRecipeLiveUpdate(initialRecipe) {
  const [liveRecipe, setLiveRecipe] = useState(initialRecipe);

  useEffect(() => {
    setLiveRecipe(initialRecipe);
  }, [initialRecipe]);

  const targetId = useMemo(() => {
    return initialRecipe?.recipe_id || initialRecipe?.id;
  }, [initialRecipe]);

  const topic = useMemo(() => {
    if (!targetId) return null;
    if (!initialRecipe?.clientCode && !initialRecipe?.client_code) return null;

    return `/topic/recipe-${targetId}`;
  }, [targetId, initialRecipe]);

  const handleMessage = useCallback((event) => {

    try {
      const { type, payload } = event;

      if (type === "DELETED") return;
      const incomingId = String(payload?.id || payload?.recipe_id);
      const currentId = String(targetId);

      if (type === "UPDATED" && incomingId === currentId) {
        const normalizedPayload = {
          ...payload,
          recipe_id: payload.id || payload.recipe_id,
          clientCode: payload.clientCode || payload.client_code,
          ingredientsList: payload.ingredients_list || payload.ingredientsList,
          nutritionalFacts: payload.nutritional_facts || payload.nutritionalFacts,
          imageUrl: payload.image_url || payload.imageUrl,
          needsPreparation:
            payload.needs_preparation !== undefined
              ? payload.needs_preparation
              : payload.needsPreparation
        };

        setLiveRecipe(normalizedPayload);
      }

    } catch (err) {
      console.error("Erro ao processar update live da receita:", err);
    }
  }, [targetId]);

  useEffect(() => {
    if (!topic) return;

    WebSocketManager.subscribe(topic, handleMessage);

    return () => {
      WebSocketManager.unsubscribe(topic);
    };
  }, [topic, handleMessage]);

  return liveRecipe;
}